import React from 'react';
import ReactDOM from 'react-dom';
import { Router, Route, hashHistory, IndexRoute } from 'react-router';
import injectTapEventPlugin from 'react-tap-event-plugin';
import App from './App';
import Capa from './componentes/capa/Capa';
import Info from './componentes/info/Info';
import Carta1 from './componentes/carta1/Carta1';
import Jogador from './componentes/jogador/Jogador';
import CartaX from './componentes/cartax/CartaX';
import Terminar from './componentes/terminar/Terminar';
import Categoria from './componentes/categoria/Categoria';
import MinhasHistorias from './componentes/minhashistorias/MinhasHistorias';
import MostraHistoria from './componentes/mostrahistoria/MostraHistoria';
import GuardaHistoria from './componentes/guardahistoria/GuardaHistoria';
import GuardaHistoriaEAutor from './componentes/guardahistoriaeautor/GuardaHistoriaEAutor';
import GuardaEAutoriza from './componentes/guardaeautoriza/GuardaEAutoriza';
import './index.css';

injectTapEventPlugin();

ReactDOM.render(
  <Router history={hashHistory}>
    <Route path="/" component={App}>
      <IndexRoute component={Capa} />
      <Route path="/capa" component={Capa} />
      <Route path="/info" component={Info} />
      <Route path="/carta1" component={Carta1} />
      <Route path="/jogador" component={Jogador} />
      <Route path="/categoria" component={Categoria} />
      <Route path="/cartax" component={CartaX} />
      <Route path="/terminar" component={Terminar} />
      <Route path="/minhashistorias" component={MinhasHistorias} />
      <Route path="/mostrahistoria" component={MostraHistoria} />
      <Route path="/guardahistoria" component={GuardaHistoria} />
      <Route path="/guardaeautoriza" component={GuardaEAutoriza} />
      <Route path="/guardahistoriaeautor" component={GuardaHistoriaEAutor} />
    </Route>
  </Router>,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js